query propstackChildrenMultiCompanyConfig($companyId: ID!) {
  propstackChildrenMultiCompanyConfig(companyId: $companyId) {
    companyId
    teamId
  }
}
